export default __webpack_public_path__ + "static/media/gallery_00.05ffb6d0.jpg";